import { generators as installations } from './installations';
import { generators as oauth } from './oauth';
import { generators as pullRequests } from './pullRequests';
import { generators as organizations } from './organizations';
import { generators as projects } from './projects';

export const generators = {
  installations,
  oauth,
  pullRequests,
  organizations,
  projects,
};
